import { useSetAtom } from "jotai";
import { useReactFlow } from "@xyflow/react";
import {
  edgesAtom,
  nodesAtom,
  sideBarSelectedAtom,
  startStreamingProgressSetter,
} from "@zapier/canvas-state";
import { handleCloseModalSetter } from "../atoms/handleCloseModalSetter";
import { usePromptToZslToCanvas } from "./usePromptToZslToCanvas";
import { outlineAtom, partialOutlineAtom } from "../atoms/outlineAtom";

export function useStreamingPrompt() {
  const { onPromptSubmit } = usePromptToZslToCanvas();
  const handleCloseModal = useSetAtom(handleCloseModalSetter);
  const setNodes = useSetAtom(nodesAtom);
  const setEdges = useSetAtom(edgesAtom);
  const setOutline = useSetAtom(outlineAtom);
  const setPartialOutline = useSetAtom(partialOutlineAtom);
  const startProgressAnimation = useSetAtom(startStreamingProgressSetter);
  const { setViewport } = useReactFlow();
  const setSideBarSelected = useSetAtom(sideBarSelectedAtom);

  const submitPrompt = (args: any) => {
    setSideBarSelected("copilot");
    handleCloseModal();
    setOutline("");
    setPartialOutline("");
    setNodes([]);
    setEdges([]);

    /* So the streaming nodes are visible and not covered by copilot sidebar.
       Doesn't work for AI page for some reason, prolly 'cuz there no node. But works for blank canvas AI mode. */
    setViewport({ x: 350, y: 60, zoom: 0.9 });
    startProgressAnimation();
    onPromptSubmit(args);

    return args;
  };

  return { submitPrompt };
}
